module.exports = "<hot-table [minSpareRows]=\"0\" [height]=\"600\" [manualColumnResize]=\"true\" [autoColumnSize]=\"true\" [startRows]=\"35\" [height]=\"600\" [rowHeaders]=\"rowHeaders\" [columns]=\"columns\" [data]=\"data\" hotId=\"FunctionalCategories\">\n</hot-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/functional-categories/functional-categories.component.html
// module id = ./src/app/functional-categories/functional-categories.component.html
// module chunks = main